import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=7b9bb5aa&scoped=true"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=7b9bb5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9bb5aa",
  null
  
)

export default component.exports